import styled from "styled-components";

const Container = styled.div`
  height: 100vh;
  width: 100%;

  position: relative;

  @media print {
    height: 1123px;
    width: 793px;
  }
`;

const ImageContent = styled.img`
  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  object-fit: cover;
`;

const Content = styled.div`
  width: 100%;
  height: 100vh;
  padding: 48px 32px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: absolute;
  top: 0;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.img``;

const FooterOfCover = styled.footer`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 10px;
`;

const FooterIcon = styled.img`
  width: 48px;
  height: 56px;
`;

const FooterDescription = styled.span`
  max-width: 360px;
  font-size: 47.73px;
  font-family: "Open Sans";
  font-weight: 400;
  line-height: 45.43px;
  color: var(--white);
  padding-bottom: 280px;

  @media print {
    padding-bottom: 450px;
  }
`;

const FooterDescriptionStronger = styled.strong`
  font-size: 47.73px;
  font-family: "Open Sans";
  font-weight: 700;
  line-height: 45.43px;

  color: var(--white);
`;

export {
  Container,
  ImageContent,
  Content,
  Header,
  Logo,
  FooterOfCover,
  FooterIcon,
  FooterDescriptionStronger,
  FooterDescription,
};
